module.exports = __webpack_public_path__ + "img/图1-38圆角和连接圆弧的徒手画法.e06d028b.png";